import { render, staticRenderFns } from "./SendDocumentsFromApplicationForm.vue?vue&type=template&id=133f0d1c&scoped=true&"
import script from "./SendDocumentsFromApplicationForm.vue?vue&type=script&lang=js&"
export * from "./SendDocumentsFromApplicationForm.vue?vue&type=script&lang=js&"
import style0 from "./SendDocumentsFromApplicationForm.vue?vue&type=style&index=0&id=133f0d1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f0d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133f0d1c')) {
      api.createRecord('133f0d1c', component.options)
    } else {
      api.reload('133f0d1c', component.options)
    }
    module.hot.accept("./SendDocumentsFromApplicationForm.vue?vue&type=template&id=133f0d1c&scoped=true&", function () {
      api.rerender('133f0d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue"
export default component.exports